<template>
  <div>
    <!--TODO: TOC Expansion: TOC branding/Delivery Hero/UNC One Card -->
    <login :loginData="faqData.loginData" :businessInfo="faqData.businessInfo" />
    <h2 class="faqstyle">Frequently Asked Questions</h2>

    <div style="width: 90%; margin-left: auto; margin-right: auto">
      <div>
        <h3>What fees are associated with the service?</h3>
        <span
          >Your delivery fee is calculated once you select a restaurant, and updated throughout the order placement process so that you will
          always know the delivery fee amount. A delivery fee of $2.99 to $3.49 is standard, but you may see higher fees if you order from
          restaurants farther away. A service fee of up to 30% may apply depending upon your city and the restaurant you're ordering from.
          Some restaurants charge additional fees, which are noted on that restaurant's menu. If you have any questions about fees or
          charges for your order, please feel free to contact us anytime!</span
        >
      </div>
      <div>
        <h3>Why does it take an hour to receive my food?</h3>
        <span
          >Please understand that your order is individually prepared by the restaurant after we place it for you. It is our goal to get
          your food to you as quickly as possible, but there are things outside of our control (in-house restaurant volume, traffic,
          weather, etc.), so we usually estimate 40 minutes to 1 hour for your order to arrive hot and fresh! Here is what happens once you
          place your order for “ASAP Delivery”: In the first 5 to 10 minutes after we receive your order, we review it, process your payment
          and then place that order with the restaurant. If we, have any questions about your order details, we will contact you so we can
          make sure that you receive what you are expecting. Once the restaurant receives your order from us, it usually takes 15 to 30
          minutes for them to prepare your food. We do our best to have the restaurant provide us with an estimated time that the food will
          be ready for delivery. In advance of the food being ready, we will dispatch your Delivery Hero to that restaurant. Once your
          Delivery Hero picks the food up, it usually takes them 10 to 25 minutes to deliver the food. This means that in a perfect world,
          you should receive your order in 30 minutes, but an hour is usually “about right”. During this process, you will receive: an order
          confirmation email with your expected delivery time immediately after you place your order with {{faqData.businessInfo.businessName}}, an email or text
          notification when your Delivery Hero has arrived at the restaurant, and another notification when they are en route to your
          location. If we have any delays in facilitating your order through this process, we'll be sure to let you know.</span
        >
      </div>
      <div>
        <h3>My order is missing something or was prepared incorrectly. Why didn't the Delivery Hero check the order? What do I do?</h3>
        <span
          >For reasons of food safety, Delivery Heroes are not permitted to handle your food after it's prepared by the restaurant. While
          this makes it difficult to catch some errors, it also helps to preserve the quality of your food. If there is an error with your
          order, please let us know ASAP and we will work with the restaurant and the Delivery Hero to get a corrected, or missing item to
          you, or remove any related charge(s) - whichever you prefer.</span
        >
      </div>
      <div>
        <h3>What if I need to cancel my order?</h3>
        <span
          >Just like ordering at a restaurant, within minutes of placing your order, the kitchen is very likely beginning to prepare your
          food. So, once you place your order with {{faqData.businessInfo.businessName}}, you are responsible for paying for it. Orders placed in advance for a
          later date or time may be cancelled only if cancelled before the restaurant begins to prepare that order. If you do want to change
          your order after placing it, please let us know ASAP and we will do as much as possible within our abilities, and the goodwill of
          the participating restaurant, to accommodate your request(s). Additional costs may apply depending upon the request and/or the
          circumstances.</span
        >
      </div>
      <div>
        <h3>Do I need to tip my Delivery Hero?</h3>
        <span
          >Just like a waiter or waitress in your local restaurant, Delivery Heroes work for tips. Your Delivery Hero is not paid an hourly
          wage; their only compensation is a small fee for each order that they complete, plus any tips you may provide. These folks must
          maintain their own vehicles and pay for their own fuel. If you have received great service, please tip your Delivery Hero! If you
          have received poor service please don't take it out on them! Please contact {{faqData.businessInfo.businessName}} and together we will find a solution
          for you.</span
        >
      </div>
      <div>
        <h3>Does {{faqData.businessInfo.businessName}} offer Gift Cards?</h3>
        <span
          >Yes, we do! You can order a gift card by clicking <a href="/giftcards">here</a>. The purchaser will receive a confirmation email
          and the gift card recipient will receive an email with the unique gift card code used to order.</span
        >
      </div>
      <div>
        <h3>Why do you charge an automatic gratuity on orders over $75?</h3>
        <span
          >Just as many dine-in restaurants add an automatic gratuity for large parties, a 15% gratuity is added to orders with a food value
          greater than $75. Large orders often take more than 1 hour for the delivery professional to complete, whereas the goal for our
          delivery professionals is usually multiple orders per hour. The automatic gratuity helps to ensure that your Delivery Hero is
          fairly compensated for their time.</span
        >
      </div>
      <div>
        <h3>A group of my friends and I want to order to a single location; can we pay separately?</h3>
        <span
          >Generally no, but split payments may be processed at the discretion of the {{faqData.businessInfo.businessName}} staff (because splitting payments
          takes more time and may cost more money). An automatic gratuity of 15% is applied to each order with split payments. Also at the
          discretion of the {{faqData.businessInfo.businessName}} staff, the delivery fee(s) may, or may not, be divided equally among these orders.</span
        >
      </div>
      <div>
        <h3>What if I want to order from more than one restaurant?</h3>
        <span
          >Not a problem! Additional fees apply as described here. We recommend keeping the number of restaurants to 2 or less so that your
          food can arrive in a reasonable amount of time and in the best condition possible. Please allow longer delivery times for orders
          from more than one restaurant.</span
        >
      </div>
      <div>
        <h3>Is there a minimum amount of food I must order?</h3>
        <span>Yes, all orders must have at least a $10.00 food total.</span>
      </div>
      <div>
        <h3>I ordered over the phone - why was I emailed about my online account?</h3>
        <span
          >When you order with {{faqData.businessInfo.businessName}} over the phone, we create an account for you in our system, just as you would have done if
          you ordered online. Our system generates a random password for your account and emails it to you so that you may use your account
          to order online in the future, if you wish.</span
        >
      </div>
      <div>
        <h3>What is your refund policy?</h3>
        <span
          >Refunds are offered at the discretion of {{faqData.businessInfo.businessName}} under limited circumstances. If you notice any errors with your order or
          concerns about our service to you, please let us know as soon as possible. We can only fix problems if we know about them, and we
          can only improve our service to you, if we're aware of our mistakes. We love feedback from our customers!</span
        >
      </div>
      <div>
        <h3>What do you do with my information?</h3>
        <span
          >We are committed to the security of your data and information. We never share any information with anyone outside of our company.
          We only store it for your convenience, so that you may reuse your same information the next time your order. For a full
          explanation of our privacy policy, please see our privacy policy.</span
        >
      </div>
      <div>
        <h3>What are your office hours?</h3>
        <span
          >We are pleased to serve you 7 days a week between the hours of 10am to 10pm. We will usually be closed on major Federal Holidays;
          notices and updates will be provided online in these instances.</span
        >
      </div>
      <div>
        <h3>What forms of payment do you accept?</h3>
        <span
          >We take Visa, MasterCard, Discover, American Express, and the UNC One Card. We do not take cash for the safety of your Delivery
          Hero.</span
        >
      </div>
      <div>
        <h3>Who can I contact if I have a problem?</h3>
        <span
          >Please feel free to email {{ faqData.businessInfo.csrEmail }} which is received by our office staff immediately. It is our goal
          to respond to all email requests within 30 minutes! Or, you may also call your local office at the numbers below. During office
          hours, we will assist you as quickly as possible. After hours, please leave a message and we will get back in touch with you as
          soon as possible the next day.</span
        >
        <ul style="list-style-type: none">
          <li v-for="(market, i) in markets" :key="i">{{ market.rdsPhone }} {{ market.cityAndState }}</li>
        </ul>
      </div>
      <div>
        <h3>How do I delete my Account?</h3>
        <span
          >Click the link
          <a :href="'https://' + faqData.businessInfo.subdomain + '/delete-profile'">here</a>
          to find out how to delete your account. You must logged in to be able to delete the account.</span
        >
      </div>
      <div>
        <h3>Do you have a nifty membership that hooks me up with free deliveries, just like those fancy bigwig companies?</h3>
        <span
          >We sure do! We are currently testing our brand new subscription-based membership called TOC+. Click
          <a href="https://l.linklyhq.com/l/1sZUV">here</a> for all the details on how to join this exclusive club, getting perks and deals
          that won't be found anywhere else!</span
        >
      </div>
    </div>
    <out-foot :homePageLinks="faqData.homePageLinks" :businessSocial="faqData.businessSocial" :businessInfo="faqData.businessInfo" />
  </div>
</template>
<script>
import Login from '../../page-components/Login.vue'
import OutFoot from '../../page-components/OutFoot.vue'

export default {
  components: {
    Login,
    OutFoot,
  },
  created() {
    this.faqData = window.faqData ? window.faqData : {}
    this.markets = window.faqData.markets ? window.faqData.markets : {}
  },
  data: function () {
    return {
      faqData: {},
      markets: [],
    }
  },
}
</script>
